const { SvgConstants } = require("../config/config");
const { parseSVG, makeAbsolute } = require("svg-path-parser");
const xLinkNS = "http://www.w3.org/1999/xlink";

function addSingleLineTranscripts(transcript, svgOverlayNode) {
    let textPaths = Array.from(transcript.querySelectorAll("g.surface > g.zone > text"));
    let linePaths = [];
    textPaths.forEach((tp) => {
        const tpEl = tp.querySelector("textPath");
        if(tpEl) {
            const id = tp.querySelector("textPath").getAttributeNS(xLinkNS, "href").substring(4)
            const nodeId = "#lp-" + id;
            const textPathId = "#tp-" + id;
            if(!id) {
                console.error("Cannot find any id for ", tpEl);
            } else if(!transcript.querySelector(textPathId)) {
                console.error("Cannot find textPath for ", textPathId);
            } else {
                linePaths.push({
                    id,
                    node: transcript.querySelector(nodeId),
                    text: tp.cloneNode(true),
                    textPath: transcript.querySelector(textPathId),
                    fontSize: tp.style.fontSize
                });
            }
        }
    });
    for (const linePath of linePaths) {
        const { id, node, text, textPath } = linePath;
        textPath.addEventListener("click", (evt) => textPathClicked(Object.assign(evt, { data: id })));
        textPath.addEventListener("mouseenter", (evt) => displayTooltip(Object.assign(evt, { data: id })));
        textPath.addEventListener("mouseleave", (evt) => hideTooltipIfNoFocus(Object.assign(evt, { data: id })));        
        const textElement = newTextNode(id, text, node.getAttribute("d"));
        textElement.setAttribute("filter", 'url(#tooltipfilter)');
        // textElement.addEventListener("mouseenter", (evt) => displayTooltip(Object.assign(evt, { data: id })));
        // textElement.addEventListener("mouseleave", (evt) => hideTooltipIfNoFocus(Object.assign(evt, { data: id })));
        // textElement.addEventListener("click", (evt) => textPathClicked(Object.assign(evt, { data: id })));
        if(textPath) {
            svgOverlayNode.appendChild(textPath);
        } else {
            console.error("Could not add textPath", linePath);
        }
        svgOverlayNode.appendChild(textElement);
    }
}

function displayTooltip(evt) {
    const id = evt.data;
    const tt = document.getElementById("tt-" + id);
    if(tt) {
        tt.classList.remove("is-hidden");
    } else {
        console.error("Could not find tooltip for", id);
    }
}

function hideTooltipIfNoFocus(evt) {
    const id = evt.data;
    const tt = document.getElementById("tt-" + id);
    if(tt && !tt.classList.contains("tp-focus")) {
        tt.classList.add("is-hidden");
    }
}

function newTextNode(id, origTextNode, d) {
    const element = document.createElementNS(SvgConstants.NS, "text");
    const absolutePath = makeAbsolute(parseSVG(d));
    // calculate the angle of the intersection of the current line with the horizontal line ( y = 0 ) and then rotate the overlay accordingly
    const x1 = absolutePath[0].x;
    const y1 = absolutePath[0].y;
    const x2 = absolutePath[absolutePath.length - 1].x;
    const y2 = absolutePath[absolutePath.length - 1].y;
    const vector1 = x2 - x1;
    const vector2 = y2 - y1;
    const z = vector1;
    const n = Math.sqrt(Math.pow(vector1, 2) + Math.pow(vector2, 2))
    const sign = y1 > y2 ? -1 : 1;
    const angle = sign * Math.acos(z / n) * 180 / Math.PI;

    element.setAttribute("class", "line tooltip is-hidden");
    element.setAttribute("id", "tt-" + id);
    element.setAttribute("x", x1);
    element.setAttribute("y", y1);
    element.setAttribute("style", origTextNode.getAttribute("style"));
    element.style.fontSize = 1.25 * SvgConstants.BASE_FONT_SIZE + "px";
    element.setAttribute("transform", `rotate(${angle}, ${x1}, ${y1}) translate(0,-200)`);

    const textPath = origTextNode.getElementsByTagName("textPath");
    if(textPath.length) {
        Array.from(textPath[0].childNodes).forEach((c) => {
            element.appendChild(c);
        });
    }

    return element;
}

function textPathClicked(evt) {
    const id = evt.data;
    const tt = document.getElementById("tt-" + id);
    evt.target.classList.toggle("tp-focus");
    tt.classList.toggle("tp-focus")
    hideTooltipIfNoFocus(evt);
}

module.exports = { addSingleLineTranscripts }